import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { fontFamilies } from "../../../design-system/tokens/typography";
import { fontSizes, lineHeights } from "@magicbi/ui-library";

/** 17/30, weight 500. */
export const Sentence = styled.p`
  margin: 0;
  font-family: ${fontFamilies.sans};
  font-size: ${fontSizes["17"]};
  font-weight: 500;
  line-height: ${lineHeights["30"]};
  color: ${rawColors.text.mediumEmphasis};
`;
